export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11018.d08ead5b.jpg";